'use strict';
var $ = require('jquery'),
  Backbone = require('backbone'),

  SliderFeature = Backbone.View.extend({
    events: {
      'click .BannerHome--content-item': 'hanldeSlideMobile',
      'click .BannerHome--content-controlItem': 'hanldeSlideDesktop'
    },
    initialize: function() {
      this.$jsItemImage = this.$el.find('.BannerHome--content-item')
      this.$jsItemItemControl = this.$el.find('.BannerHome--content-controlItem')
      this.$control = this.$el.find('.BannerHome--content-control')
      this.isActive = 'is-active'
      this.iconPlus = 'Icon--plus'
      this.iconMinus = 'Icon--minus'
      this.$isEditer =  $('.is-editor-mode')
      this.openContent = '.BannerHome--content-open'
      this.maxHeight = 'max-height'
      this.firstActive = 'first-active'
      this.runAnimation = 'run-animation'
      this.ariaSelected = 'aria-selected'
      this.ariaExpanded = 'aria-expanded'
      this.spanIcon = 'span.Icon'
      this.aButton = 'a, button'
      this.tabindex = 'tabindex'
      this.header = 'header'
      this.controlCloneButton()
      $('html').removeClass('hidden')
    },
    hanldeSlideDesktop(e) {
      if (!this.$isEditer.length)  {
        const $elm = $(e.currentTarget)
        const $jsItemItemControl = this.$el.find('.BannerHome--content-controlItem')
        if ($elm.hasClass(this.isActive)) {
          $jsItemItemControl.addClass(this.runAnimation).removeClass(this.isActive).attr(this.ariaSelected, false).find(this.spanIcon).removeClass(this.iconMinus).addClass(this.iconPlus)
          this.$jsItemImage.removeClass(this.isActive).find(this.aButton).attr(this.tabindex, '-1')
          $(this.$jsItemImage[0]).addClass(this.isActive).find(this.aButton).attr(this.tabindex, '0')
          $($jsItemItemControl[0]).addClass(this.isActive).attr(this.ariaSelected, true).find(this.spanIcon).addClass(this.iconMinus).removeClass(this.iconPlus)
          $(this.$control[0]).addClass(this.firstActive)
          setTimeout(() => {
            $jsItemItemControl.attr(this.tabindex, '-1').attr('aria-selected', false)
            $($jsItemItemControl[0]).attr('aria-selected', true).attr(this.tabindex, 0).focus()
          }, 500)
        } else {
          $jsItemItemControl.addClass(this.runAnimation).removeClass(this.isActive).attr(this.ariaSelected, false)
            .find(this.spanIcon).removeClass(this.iconMinus).addClass(this.iconPlus)
          this.$jsItemImage.removeClass(this.isActive).find(this.aButton).attr(this.tabindex, '-1')
          $(this.$jsItemImage[$elm.index()]).addClass(this.isActive).find(this.aButton).attr(this.tabindex, '0')
          $elm.addClass(this.isActive).attr(this.ariaSelected, true).find(this.spanIcon).addClass(this.iconMinus).removeClass(this.iconPlus)
          if ($elm.index() === 0) {
            this.$control.addClass(this.firstActive)
          } else {
            this.$control.removeClass(this.firstActive)
          }
        }
        setTimeout(() => {
          $jsItemItemControl.removeClass(this.runAnimation)
        } ,1000)
      }
    },
    hanldeSlideMobile(e) {
      if ($(window).innerWidth() < 1024) {
        const $elm = $(e.currentTarget)
        this.$jsItemImage.css(this.maxHeight,'')
        let heightAdd = 0
        if ($(window).innerWidth() >= 720) {
          heightAdd = 121
        }
        $elm.css(this.maxHeight,$elm.find('.BannerHome--content-wrapItem').innerHeight() + heightAdd)
        if ($elm.hasClass(this.isActive)) {
          $elm.removeClass(this.isActive)
          this.$jsItemImage.removeClass(this.isActive).find(this.openContent).attr(this.ariaExpanded, false).find(this.spanIcon).removeClass(this.iconMinus).addClass(this.iconPlus)
          $(this.$jsItemImage[0]).addClass(this.isActive).find(this.openContent).attr(this.ariaExpanded, true).find(this.spanIcon).addClass(this.iconMinus).removeClass(this.iconPlus)
          $elm.css(this.maxHeight,'')
          $(this.$jsItemImage[0]).css(this.maxHeight, $(this.$jsItemImage[0]).find('.BannerHome--content-wrapItem').innerHeight() + heightAdd)
        } else {
          this.$jsItemImage.removeClass(this.isActive).find(this.openContent).attr(this.ariaExpanded, false).find(this.spanIcon).removeClass(this.iconMinus).addClass(this.iconPlus)
          this.$jsItemImage.find(this.aButton).attr(this.tabindex, '-1')
          $(this.$jsItemImage[$elm.index()]).addClass(this.isActive).find(this.openContent).attr(this.ariaExpanded, true)
          $(this.$jsItemImage[$elm.index()]).find(this.aButton).attr(this.tabindex, '0')
          $(this.openContent).attr(this.tabindex, '0')
          $elm.addClass(this.isActive).find(this.spanIcon).addClass(this.iconMinus).removeClass(this.iconPlus)
        }
        if (this.$el.height() > $(window).height() - $(this.header).innerHeight()) {
          setTimeout(() => {
            $('html,body').animate({scrollTop: $('.BannerHome--content-item.is-active').offset().top - $(this.header).innerHeight() + 10 }, 500);
          }, 650)
        }
      } else {
        this.$jsItemImage.css(this.maxHeight,'')
      }
    },
    controlCloneButton() {
      if (!this.$isEditer.length) {
        const cloneControlItem = this.$jsItemItemControl.clone()
        this.$control.append(cloneControlItem)
        this.$control.find('button').attr('role', 'tab')
        this.$control.find('button').each((i,el) => {
          $(el).attr('aria-selected', $(el).attr('data-aria-selected'))
          $(el).attr('aria-controls', $(el).attr('data-aria-controls'))
          if (i === 0) {
            $(el).attr('tabindex', '0')
          } else {
            $(el).attr('tabindex', '-1')
          }
        })
        this.$jsItemItemControl.remove()
      }
    }
  }, {
    create: function create($parent) {
      $parent.find('.BannerHome').each((n, el) => {
        new SliderFeature({
          el: el
        });
      });
    }
  });

module.exports = SliderFeature;


// WEBPACK FOOTER //
// ./assets/components/BannerHome/BannerHome.js